<template>
  <div class="sidebar__header">
    <div class="sidebar__title">
      <div class="sidebar__close-btn" @click="close" />
      Select Category
    </div>
    <div v-if="mode === 'compare'" class="sidebar__tabs">
      <div class="sidebar__tab" :class="{ active: appSlot === 'main' }" @click="selectSlot('main')">
        X Axis
      </div>
      <div class="sidebar__tab" :class="{ active: appSlot === 'pair' }" @click="selectSlot('pair')">
        Y Axis
      </div>
      <div class="sidebar__tab" :class="{ active: appSlot === 'size' }" @click="selectSlot('size')">
        Size
      </div>
    </div>
    <div class="sidebar__search">
      <div class="sidebar__search-input" :class="{ waiting: waiting }">
        <input
          v-model="searchPattern"
          class="searcher"
          type="text"
          placeholder="Search indicators"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { searchIndicators } from '../../services/api.js'

const debounce = (function() {
  let cleaner = function() {}
  let debounced

  return function({ fn, args, context }) {
    var closed = false;
    clearTimeout(debounced)
    cleaner()
    let promise = new Promise((resolve, reject) => {
      cleaner = () => reject()
      debounced = setTimeout(() => {
        if (closed === false) {
          let call = Array.isArray(args) ? fn.apply(context, args) : fn.call(context, args)
          call
            .then(result => {
              if (closed === true) {
                reject('Closed promise')
              } else {
                resolve(result)
              }
            })
            .catch(err => reject(err))
        }
      }, 500)
    })

    promise.close = function() {
      closed = true
    }

    return promise
  }
})()

export default {
  model: {
    prop: 'appSlot',
    event: 'appslot',
  },
  props: ['appSlot', 'isActive'],
  data() {
    return {
      searchPattern: null,
      openSearch: null,
      waiting: false,
    }
  },
  computed: {
    mode() {
      return this.$route.params.mode
    },
    version() {
      return this.$route.params.version
    },
    mainIndId() {
      return this.$store.state.query.mainIndId
    },
  },
  watch: {
    isActive (to) {
      if (!to) {
        // Manual reset from outside the component
        this.searchPattern = null;
      }
    },
    searchPattern(to, from) {
      if (!to) {
        this.openSearch && this.openSearch.close()
        this.waiting = false
        this.openSearch = null
        if (to === '') {
          // When search pattern is an empty string, then emit an empty result without search flag
          this.$emit('search:result', {res:[], pattern: this.searchPattern})
          // if it isn't means it's a manual reset from above and the header shouldn't say nothing
        }
      } else {
        this.openSearch = debounce({ fn: this.search, args: to, context: this })
        this.openSearch
            .then(res => {
              if (res) {
                if (res.length === 0) {
                  res.push({ id: null })
                }
                this.$emit('search:result', {res:res, pattern: this.searchPattern})
              }
              this.waiting = false
              this.openSearch = null
            })
            .catch(() => {})
      }
    },
  },
  methods: {
    search(pattern) {
      if (!pattern) {
        return Promise.resolve([])
      } else {
        this.waiting = true
        return searchIndicators({
          query: pattern,
          versionId: this.version,
        }).catch(err => {
          console.warn(err)
          this.waiting = false
        })
      }
    },
    close() {
      this.searchPattern = null
      this.$emit('close')
    },
    selectSlot(slot) {
      this.$emit('appslot', slot)
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="stylus">
.sidebar__header
  display: flex
  flex-direction: column
  position: relative

.sidebar__close-btn
  m-icon("close", 30)
  cursor: pointer
  left: vw(20px)
  position: absolute
  top: 50%
  transform: translateY(-50%)

  .mobile &
    +m-breakpoint(landscape)
      m-icon("close", 15)

.sidebar__title
  align-items: center
  border-bottom: 1px solid $blue
  color: $blue
  display: flex
  font-weight: 700
  justify-content: center
  padding: vw(25vw) vw(75px) vw(25vw) vw(50px)
  position: relative
  text-align: center
  font-size: .98em
  line-height: 1.2

  .mobile &
    +m-breakpoint(landscape)
      padding: vh(15px) 0
      text-align: center

.sidebar__search
  border-bottom: 1px solid $blue
  padding: vw(10vw) vw(15px)

  .mobile &
    +m-breakpoint(landscape)
      padding: vh(10vh) vw(15px)

.sidebar__search-input
  background-color: $light-gray
  border-radius: vw(15px)
  padding: vw(15px) vw(30px)
  position: relative

  .mobile &
    padding: vw(10px) vw(20px)

    +m-breakpoint(landscape)
      padding: vh(5px) vw(15px)

  &.waiting
    &:after
      display: block

  &:before
    m-icon("search-lens", 30)
    content: ""
    display: block
    left: vw(15px)
    position: absolute
    top: 50%
    transform: translateY(-50%)

    .mobile &
      +m-breakpoint(landscape)
        m-icon("search-lens", 15)

  &:after
    content: ""
    display: none
    height: 20px
    position: absolute
    right: 0.5em
    top: calc(50% - 10px)
    transform: translateY(-50%)
    width: @height
    m-spinner(1px, $blue)

  .searcher
    m-font-size(18, 22)
    background-color: transparent
    border: none
    outline: none
    padding: 0.5em vw(40px)
    width: 100%

    .mobile &
      +m-breakpoint(landscape)
        font-size: 0.98em
        line-height: 1.2
        padding: 0.5em vw(20px)

    &::placeholder
      color: $blue

.sidebar__tabs
  display: flex

.sidebar__tab
  border-bottom: 1px solid #eee
  cursor: pointer
  flex: 1
  font-size: 1.1em
  padding: 1em 2em 0.8em
  text-align: center

  .mobile &
    font-size: .9em

    +m-breakpoint(landscape)
      padding: 0.5em 1em .4em

  &:hover,
  &.active
    border-bottom-width: 2px

  &.active
    border-color: #ccc
</style>
